<form id="addFoodToPlanForm" name="addFoodToPlanForm" (ngSubmit)="addFoodToPlan()" #addFoodToPlanForm="ngForm" method="post" class="table-responsive">
  @if(isFoodAddedSuccessfully){
  <div class="alert alert-success alert-dismissible fade show" role="alert">
    <strong>Well done!</strong> You added a food entry to your meal plan. Click on the <strong>"Meal Plan"</strong> tab to review your entries.
    <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
  </div>
  }

  <table class="table">
    <thead>
      <tr>
        <th scope="col">Food</th>
        <th scope="col">Quantity</th>
        <th scope="col">Unit of Measure</th>
        <th scope="col">Alcohol</th>
        <th scope="col">Netcarbs</th>
        <th scope="col">Fat</th>
        <th scope="col">Protein</th>
        <th scope="col">Calories</th>
        <th class="d-none" scope="col">Submit</th>
      </tr>
    </thead>
    <tbody class="table-group-divider">
      <tr>
        <td class="first-td">
          <div class="awesomplete-wrapper">
            <input attr.data-testid="{{ mealType.toLowerCase() }}_food_name" id="foodName_{{mealType}}" name="foodName_{{mealType}}" #foodName="ngModel"
              [(ngModel)]="selectedFoodName" (awesomplete-highlight)="getSelectedFoodDetails($event)" (awesomplete-select)="getSelectedFoodDetails($event)"
              (change)="getSelectedFoodDetails($event)" placeholder="Name of food" class="form-control" required />

            @if(foodName.invalid && (foodName.dirty || foodName.touched)){
            @if(foodName.hasError('required')){
            <div class="invalid-feedback">Food name is required.</div>
            } }
          </div>
        </td>
        <td>
          <input attr.data-testid="{{ mealType.toLowerCase() }}_food_serving_size" id="{{ mealType.toLowerCase() }}FoodServingSize"
            name="{{ mealType.toLowerCase() }}FoodServingSize" class="form-control" type="number" #foodServingSize="ngModel" [(ngModel)]="selectedFoodServingSize"
            title="Quantity" placeholder="0" [min]="0.01" [max]="2000" step="0.1" [value]="selectedFood?.servingSize"
            (input)="updateCaloriesAndMacrosForFoodEntry($event)" required />

          @if(foodServingSize.invalid && (foodServingSize.dirty ||
          foodServingSize.touched)){ @if(foodServingSize.hasError('required')){
          <div class="invalid-feedback">Food quantity is required.</div>
          } @if(foodServingSize.hasError('min')){
          <div class="invalid-feedback">
            Food quantity must be greater than zero.
          </div>
          } @if(foodServingSize.hasError('max')){
          <div class="invalid-feedback">
            Food quantity must be 2000 or less.
          </div>
          } }
        </td>
        @switch(selectedFood?.unitsOfMeasureId) {
        @case(1) {
        <td attr.data-testid="{{ mealType.toLowerCase() }}_unit_of_measure">g</td>
        }
        @case(2) {
        <td attr.data-testid="{{ mealType.toLowerCase() }}_unit_of_measure">oz</td>
        }
        @case(3) {
        <td attr.data-testid="{{ mealType.toLowerCase() }}_unit_of_measure">ea</td>
        }
        @case(4) {
        <td attr.data-testid="{{ mealType.toLowerCase() }}_unit_of_measure">c</td>
        }
        @case(5) {
        <td attr.data-testid="{{ mealType.toLowerCase() }}_unit_of_measure">Tbsp</td>
        }
        @case(6) {
        <td attr.data-testid="{{ mealType.toLowerCase() }}_unit_of_measure">tsp</td>
        }
        @case(7) {
        <td attr.data-testid="{{ mealType.toLowerCase() }}_unit_of_measure">pt</td>
        }
        @case(8) {
        <td attr.data-testid="{{ mealType.toLowerCase() }}_unit_of_measure">lb</td>
        }
        @case(9) {
        <td attr.data-testid="{{ mealType.toLowerCase() }}_unit_of_measure">ml</td>
        }
        @case(10) {
        <td attr.data-testid="{{ mealType.toLowerCase() }}_unit_of_measure">fl oz</td>
        }
        @default {
        <td attr.data-testid="{{ mealType.toLowerCase() }}_unit_of_measure">g</td>
        }
        }
        <td id="{{ mealType.toLowerCase() }}AlcoholQty" attr.data-testid="{{ mealType.toLowerCase() }}AlcoholQty">
          {{ quantityAdjustedSelectedFood?.alcohol ?? "0" }}
        </td>
        <td id="{{ mealType.toLowerCase() }}NetCarbsQty" [attr.data-testid]="mealType.toLowerCase() + 'NetCarbsQty'">
          {{ quantityAdjustedSelectedFood?.netcarbs ?? "0" }}
        </td>
        <td id="{{ mealType.toLowerCase() }}FatQty" attr.data-testid="{{ mealType.toLowerCase() }}FatQty">
          {{ quantityAdjustedSelectedFood?.fat ?? "0" }}
        </td>
        <td id="{{ mealType.toLowerCase() }}ProteinQty" attr.data-testid="{{ mealType.toLowerCase() }}ProteinQty">
          {{ quantityAdjustedSelectedFood?.protein ?? "0" }}
        </td>
        <td id="{{ mealType.toLowerCase() }}CaloriesQty" attr.data-testid="{{ mealType.toLowerCase() }}CaloriesQty">
          {{ quantityAdjustedSelectedFood?.calories ?? "0" }}
        </td>
        <td>
          <button attr.data-testid="{{ mealType.toLowerCase() }}_add_food_submit_btn" name="addFoodSubmitBtn" type="submit" class="btn btn-primary" title="Submit">
            Submit
          </button>
        </td>
      </tr>
    </tbody>
  </table>
</form>
